import { Beech } from './beech';

export type SetupState =
	| 'INIT'
	| 'MEDIA_ASKING'
	| 'MEDIA_REJECTED'
	| 'NOTIFICATIONS_ASKING'
	| 'NOTIFICATIONS_REJECTED'
	| 'DONE';

declare let Notification: any; // TODO

export default class Setup {
	private beech: Beech;

	public constructor(beech: Beech) {
		this.beech = beech;
	}

	public init = () => {
		// Electron auto-grants permissions in the main process, skip interactive checks
		if (window.electronAPI?.isElectron) {
			this.onceDone();
			return;
		}
		this.checkMediaPermissions();
	};

	private checkMediaPermissions = () => {
		logg.log('setup >> userMedia >> asking');

		this.beech.model.setSetupState('MEDIA_ASKING');

		navigator.mediaDevices.getUserMedia({ audio: true }).then(this.onUserMediaFulfilled, this.onUserMediaRejected);
	};

	private onUserMediaFulfilled = (data: MediaStream) => {
		logg.log('setup >> userMedia >> fulfilled');

		for (let track of data.getTracks()) {
			track.stop();
		}

		// Notifications are not supported in embedded mode
		if (this.beech.embedded.isEnabled()) {
			this.onceDone();
		} else {
			window.setTimeout(() => this.checkNotifications(), 0);
		}
	};

	private onUserMediaRejected = (reason: Error) => {
		logg.log('setup >> userMedia >> rejected', reason);

		this.beech.model.setSetupState('MEDIA_REJECTED', reason.name);
	};

	private checkNotifications = () => {
		logg.log('setup >> notifications >> asking');

		this.beech.model.setSetupState('NOTIFICATIONS_ASKING');

		Notification.requestPermission().then(this.onNotificationsFulfilled);
	};

	private onNotificationsFulfilled = (permissionStatus: string) => {
		logg.log('setup >> notifications >> ' + permissionStatus);

		switch (permissionStatus) {
			case 'granted':
				this.onceDone();
				break;

			case 'default':
				this.beech.model.setSetupState('NOTIFICATIONS_REJECTED', 'Dialog Dismissed');
				break;

			case 'denied':
				this.beech.model.setSetupState('NOTIFICATIONS_REJECTED', 'Permission Denied');
				break;

			default:
				this.beech.model.setSetupState('NOTIFICATIONS_REJECTED', 'Unknown Reason');
				break;
		}
	};

	private onceDone = () => {
		this.beech.model.setSetupState('DONE');
		this.beech.flow.onSetupComplete();
	};
}
